// Early and late shows on one date (ShowSummary.part, contract B.1 as
// extended by the backend: 'early' | 'late' | null). Rows for the two shows
// look the same otherwise, so every list that shows ShowSummary dates adds a
// small badge.

const PART = {
  early: { text: 'Early', title: 'Early show' },
  late: { text: 'Late', title: 'Late show' },
};

const dayOf = (row) => String((row && (row.iso || row.dateKey || row.displayDate)) || '').substring(0, 10).replace(/_/g, '-');

// { text, title } | null for one row, from its `part` alone.
export const partBadge = (row) => (row && PART[row.part]) || null;

// Badges for a whole list, aligned with `rows`. The server's `part` wins.
// Rows that share a date with no part read "(1 of 2)", "(2 of 2)" in list order.
export const partBadges = (rows) => {
  const list = Array.isArray(rows) ? rows : [];
  const count = {};
  list.forEach((r) => {
    const d = dayOf(r);
    if (d && !partBadge(r)) count[d] = (count[d] || 0) + 1;
  });
  const seen = {};
  return list.map((r) => {
    const own = partBadge(r);
    if (own) return own;
    const d = dayOf(r);
    const n = d ? count[d] : 0;
    if (n < 2) return null;
    seen[d] = (seen[d] || 0) + 1;
    return { text: '(' + seen[d] + ' of ' + n + ')', title: 'Show ' + seen[d] + ' of ' + n + ' on this date' };
  });
};
